//@ts-check
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import ModalWindow from '../Window';
import AppsUtils from '../../apps/utils';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    content: {
      width: '100%',
      height: '100%',
      border: 'none',
      display: 'block'
    }
  });
}, {
  name: 'ECIframeModal'
});

var IframeModal = function IframeModal(props) {
  var onClose = props.onClose,
      src = props.src,
      app = props.app,
      title = props.title;
  var classes = useStyles({});
  var height = 500;
  var url = src;
  if (app) url = AppsUtils.redirect(app, url);
  return React.createElement(ModalWindow, {
    onClose: onClose,
    borderLess: true,
    overlay: true,
    style: {
      width: 436,
      height: height,
      top: 'auto'
    },
    header: title,
    content: React.createElement("iframe", {
      title: title,
      src: url,
      className: classes.content
    })
  });
};

IframeModal.defaultProps = {};
export default IframeModal;